import { useState } from 'react';
import GridPoints from '../grid/GridPoints';
import LanguageSelect from '../select/LanguageSelect';
import ImageFigureContent from '../common/ImageFigureContent';
import BranchSelect from '../select/BranchSelect';
import YakkalaFrontImage from '../../assets/images/LoyaltyCards/Golden-lotus-front.jpg';
import YakkalaBackImage from '../../assets/images/LoyaltyCards/Golden-lotus-back.jpg';
import ColomboFrontImage from '../../assets/images/LoyaltyCards/Golden-lotus-front-colombo.jpg';
import ColomboBackImage from '../../assets/images/LoyaltyCards/Golden-lotus-back-colombo.jpg';

const LoyaltyCardContent = ({ loyaltyCardData }) => {

  const [language, setLanguage] = useState("english");
  const [branch, setBranch] = useState("colombo");

  const details = {
    yakkala: {
      frontImage: YakkalaFrontImage,
      backImage: YakkalaBackImage
    },
    colombo: {
      frontImage: ColomboFrontImage,
      backImage: ColomboBackImage
    }
  }

  const { frontImage, backImage } = details[branch];

  return (

    <div className="px-3 mb-12">

      <div className='flex w-full justify-end'>
        <BranchSelect className="" branch={branch} setBranch={setBranch} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-x-10 gap-y-6 px-4 sm:px-6 lg:px-[3%] xl:px-[8%] py-2 ">

        {/* <div className='flex flex-col md:flex-row lg:flex-col gap-x-4 items-center gap-y-3'> */}

        <div className='w-[90%] sm:w-[85%] lg:w-full 2xl:max-w-[80%] rounded-xl shadow-md transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'>
          <ImageFigureContent image={frontImage} />
        </div>

        <div className='w-[90%] sm:w-[85%] lg:w-full 2xl:max-w-[80%] rounded-xl shadow-md transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'>
          <ImageFigureContent image={backImage} />
        </div>
      </div>

      <div>

        <div className='flex mt-5 mb-3 gap-2 items-center justify-center'>

          <h3
            className="font-semibold leading-snug tracking-normal text-slate-800 mx-auto lg:mx-24 text-md md:text-lg lg:text-3xl w-full max-w-lg lg:max-w-full"
          >
            {loyaltyCardData.cardName} Loyalty Card Terms & Conditions
          </h3>

          <LanguageSelect language={language} setLanguage={setLanguage} />
        </div>

        <div className='px-2 md:px-5 lg:px-16'>
          <GridPoints gridDataArray={loyaltyCardData.inclusions[language]} />
        </div>
      </div>

    </div >

  )
}

export default LoyaltyCardContent